import * as React from 'react';

export default function ApconLogo({ className }) {
  return (
    <span
      className={`apcon-logo ${className} transition-all duration-150 ease-in-out`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 383.7 80"
        width="160"
        height="32"
        aria-hidden="true"
        className="h-7 sm:h-8"
      >
        <g className="fill-current transition-colors duration-150 ease-in-out group-focus:text-blue-600 group-hover:text-blue-600">
          <polygon points="8.57 70.4 16.79 61.7 16.79 18.12 8.57 9.85 8.57 15.69 0 15.66 0 23.34 8.57 23.34 8.55 29.71 0 29.71 0 37.26 8.55 37.26 8.55 43.48 0 43.48 0 50.29 8.55 50.29 8.55 56.94 0 56.97 0 64.06 8.55 64.06 8.57 70.4" />
          <polygon points="71.43 70.25 63.19 61.75 63.19 18.25 71.43 9.85 71.43 15.69 80 15.66 80 23.34 71.43 23.34 71.43 29.71 79.97 29.71 79.97 37.26 71.43 37.26 71.43 43.48 79.97 43.48 79.97 50.29 71.43 50.29 71.43 56.94 80 56.97 80 64.06 71.43 64.06 71.43 70.25" />
          <polygon points="70.15 71.4 62.29 63.19 17.68 63.19 9.83 71.43 15.66 71.43 15.66 80 23.34 80 23.31 71.43 29.71 71.43 29.71 79.97 37.24 79.97 37.24 71.43 43.45 71.43 43.45 79.97 50.26 79.97 50.26 71.43 56.94 71.43 56.94 80 64.03 80 64.03 71.43 70.15 71.4" />
          <polygon points="70.4 8.57 62.29 16.79 17.68 16.79 9.65 8.57 15.66 8.57 15.66 0 23.34 0 23.31 8.55 29.71 8.55 29.71 0 37.24 0 37.24 8.55 43.45 8.55 43.45 0 50.26 0 50.26 8.55 56.94 8.55 56.94 0 64.03 0 64.03 8.55 70.4 8.57" />
        </g>
        <g className="fill-current transition-colors duration-150 ease-in-out group-focus:text-base-200 group-hover:text-base-200">
          <path
            d="M160.27,72.12H141.41l-.87-9.47h-20.3l-4.83,9.47H94.68L129.79,14h20.7ZM139.39,50.36l-2-21.24h-.18l-10.7,21.27Z"
            transform="translate(-8.15)"
          />
          <path
            d="M172.09,22.7h24.8c4.66,0,8.19.51,10.54,1.51a11.47,11.47,0,0,1,5.43,4.45,13.42,13.42,0,0,1,1.87,7.25,15.8,15.8,0,0,1-3.33,9.9A18.29,18.29,0,0,1,203.06,52c-3.35,1.25-8,1.89-13.92,1.89h-7.45l-4.35,18.2H160.29ZM184,44.09h5.63A9.79,9.79,0,0,0,196.12,42a6.34,6.34,0,0,0,2.54-5c0-2.94-1.77-4.43-5.3-4.43h-6.58Z"
            transform="translate(-8.15)"
          />
          <path
            d="M391.85,22.7,380.08,72.09H364.13L350.8,43.43h-.15l-6.81,28.66H328L339.72,22.7h15.84l13.38,28.77h.16L376,22.7Z"
            transform="translate(-8.15)"
          />
          <path
            d="M252.4,52.05a18.53,18.53,0,0,1-4.17,6.25A11.42,11.42,0,0,1,240,61.63a9,9,0,0,1-6.78-2.49,8.5,8.5,0,0,1-2.46-6.24,28.7,28.7,0,0,1,1.66-8.6,18.51,18.51,0,0,1,5-8.09,11.44,11.44,0,0,1,7.91-3,9.65,9.65,0,0,1,6.76,2.4,8.09,8.09,0,0,1,2.4,4.48h16.71a20,20,0,0,0-5.7-12.13c-3.89-4-10-6-18.3-6a50,50,0,0,0-9.37.87,28.12,28.12,0,0,0-9.26,3.76,28.49,28.49,0,0,0-7.94,7.14,32.16,32.16,0,0,0-4.83,9,30.53,30.53,0,0,0-1.61,9.85c0,6.42,2.17,11.44,6.55,15s10.44,5.35,18.22,5.35a41.35,41.35,0,0,0,9.65-1.1,29.88,29.88,0,0,0,9.47-4.36,28.17,28.17,0,0,0,8-7.9A30.92,30.92,0,0,0,269.8,52Z"
            transform="translate(-8.15)"
          />
          <path
            d="M305.83,21.91q12.48,0,18.3,6A20.53,20.53,0,0,1,330,42.79a32.42,32.42,0,0,1-1.08,7.75,28.59,28.59,0,0,1-4.17,9,28.07,28.07,0,0,1-8,7.91,30.18,30.18,0,0,1-9.47,4.35,42.26,42.26,0,0,1-9.65,1.1c-7.78,0-13.87-1.79-18.22-5.35s-6.55-8.57-6.52-15a30.59,30.59,0,0,1,1.61-9.86,31.55,31.55,0,0,1,4.84-9.06,28.62,28.62,0,0,1,7.93-7.14,28.12,28.12,0,0,1,9.26-3.76A52.49,52.49,0,0,1,305.83,21.91Zm-7.19,39.72a11.39,11.39,0,0,0,8.24-3.33,19.53,19.53,0,0,0,4.94-8.37,27.94,27.94,0,0,0,1.56-7.19c0-3.15-.87-5.53-2.63-7.14A9.65,9.65,0,0,0,304,33.19a11.35,11.35,0,0,0-7.91,3.05,18.34,18.34,0,0,0-5,8.09,28.37,28.37,0,0,0-1.66,8.59,8.64,8.64,0,0,0,2.43,6.25,9.07,9.07,0,0,0,6.78,2.46Z"
            transform="translate(-8.15)"
          />
        </g>
      </svg>
    </span>
  );
}
